const HELLO_ALPHABET =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'

function getSecureRandomValues(length) {
    if (typeof crypto !== 'undefined' && crypto.getRandomValues) {
        const array = new Uint8Array(length)
        crypto.getRandomValues(array)
        return array
    } else {
        const array = []
        for (let i = 0; i < length; i++) {
            array.push(Math.floor(Math.random() * 256))
        }
        return array
    }
}

function utf8Encode(str) {
    const utf8 = []
    for (let i = 0; i < str.length; i++) {
        const charCode = str.charCodeAt(i)
        if (charCode < 0x80) {
            utf8.push(charCode)
        } else if (charCode < 0x800) {
            utf8.push(0xc0 | (charCode >> 6))
            utf8.push(0x80 | (charCode & 0x3f))
        } else {
            utf8.push(0xe0 | (charCode >> 12))
            utf8.push(0x80 | ((charCode >> 6) & 0x3f))
            utf8.push(0x80 | (charCode & 0x3f))
        }
    }
    return utf8
}

function generateRandomId(length = 24) {
    const bytes = getSecureRandomValues(length)
    let id = ''
    for (let i = 0; i < length; i++) {
        id += HELLO_ALPHABET[bytes[i] % HELLO_ALPHABET.length]
    }
    return id
}

function checksumForTab(id) {
    const prefix = 'tab'
    const pb = utf8Encode(prefix)
    const dib = utf8Encode(id)
    const a =
        (pb[0] || 0) +
        (dib[0] || 0) +
        (dib[3] || 0) +
        (dib[6] || 0) +
        (dib[9] || 0) +
        (dib[12] || 0) +
        (dib[15] || 0) +
        (dib[18] || 0)
    const b =
        (pb[1] || 0) +
        (dib[1] || 0) +
        (dib[4] || 0) +
        (dib[7] || 0) +
        (dib[10] || 0) +
        (dib[13] || 0) +
        (dib[16] || 0) +
        (dib[19] || 0)
    const c =
        (pb[2] || 0) +
        (dib[2] || 0) +
        (dib[5] || 0) +
        (dib[8] || 0) +
        (dib[11] || 0) +
        (dib[14] || 0) +
        (dib[17] || 0) +
        (dib[20] || 0)

    return (
        HELLO_ALPHABET[a % 62] + HELLO_ALPHABET[b % 62] + HELLO_ALPHABET[c % 62]
    )
}

function makeTabId() {
    const id = generateRandomId()
    const cs = checksumForTab(id)
    return `tab_${id}_${cs}`
}

// fn to verify tabid checksum
// function verifyTabId(tabId) {
//     if (typeof tabId !== 'string') return false
//     const parts = tabId.split('_')
//     if (parts.length !== 3 || parts[0] !== 'tab') return false

//     const id = parts[1]
//     const checksum = parts[2]
//     const expectedChecksum = checksumForTab(id)
//     return checksum === expectedChecksum
// }

export default makeTabId
